module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24452/sass/messagesWidgetShell.sass"